module.exports = __webpack_public_path__ + "media/images/landing/bg/case-nestle/instagram-1-0b8ce2a0f84bfb74b8f9c42e4f7aeb3a.jpg";